import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  state() {
    return {
      errorCode: null,
      redirect: false,
      errorType: 'danger' //danger - warning
    };
  },
  mutations,
  actions,
  getters
};
